import React, { Component } from 'react';

const CloseIcon = () => {
  return <img src="images/icons/close.svg" />;
};

export default CloseIcon;
